import React, { useState } from 'react'
import ShipmentDetails from '../CreateOrder/ShipmentDetails'
import Dimensions from '../CreateOrder/Dimensions'
import { Button } from '@material-tailwind/react'
import DeliveryAddress from '../CreateOrder/DeliveryAddress'
import ShipmentDetailsEdit from '../CreateOrder/ShipmentDetailsEdit'
import { doc, setDoc } from 'firebase/firestore'
import { db } from '../../firebase.config'
import toast from 'react-hot-toast'
import DilveryModal from '../CreateOrder/DilveryModal'
import { ToastContainer } from 'react-toastify'

const EditOrderPage = ({ step, setStep, dimension, setDimension, dimentionData, setDimentionData, subOrders, setSubOrders, dropLocation, setDropLocation, mode, setMode, amount, setAmount, weight, setWeight, orderID, setOrderID, lrDetails, setLrDetails, lrNumber, setLrNumber, handleDimensionData, removeDimesion, handleShippingDetails, warehouseList, pickupLocation, setPickupLocation, handleDeliveryInformation, handleConfirmOrder, handleBookOrder, userList, user, setUser, loading,
  setloading, deliveryAddresses }) => {
  const [dilveryModal, setDilveryModal] = useState(false)
  const [deliveryAddress, setdeliveryAddress] = useState("")
  const [deliveryName, setdeliveryName] = useState("")
  const [deliveryPhone, setdeliveryPhone] = useState("")
  const [deliveryCompanyName, setdeliveryCompanyName] = useState("")
  const [deliveryPincode, setdeliveryPincode] = useState("")
  const [deliveryCity, setdeliveryCity] = useState("")
  const [deliveryState, setdeliveryState] = useState("")
  const [deliveryClientId, setdeliveryClientId] = useState("")


  const handleDilveryModal = () => {
    setDilveryModal(!dilveryModal)
  }

  const AddDilveryAdress = async () => {
    console.log("Submit clicked");

    if (
      !deliveryAddress ||
      !deliveryName ||
      !deliveryPhone ||
      !deliveryCompanyName ||
      !deliveryPincode ||
      !deliveryCity ||
      !deliveryState
    ) {
      console.log("Missing fields");
      toast.error("Please fill all the fields");
      return;
    }

    try {
      const docRef = doc(db, "deliveryAddresses", deliveryName);
      await setDoc(docRef, {
        deliveryAddress,
        deliveryName,
        deliveryPhone,
        deliveryCompanyName,
        deliveryPincode,
        deliveryCity,
        deliveryState,
        deliveryClientId,
        createdAt: new Date(),
      });

      toast.success("Address saved successfully!");
      setDilveryModal(!dilveryModal);
      setdeliveryAddress("")
      setdeliveryName("")
      setdeliveryPhone("")
      setdeliveryPincode("")
      setdeliveryCity("")
      setdeliveryState("")
      setdeliveryCompanyName("")
      setdeliveryClientId("")
    } catch (error) {
      console.error("Firestore error:", error);
      toast.error("Failed to save address.");
    }
  };
  return (
    <>
      <ToastContainer />
      <DilveryModal setUser={setUser} user={user} userList={userList} AddDilveryAdress={AddDilveryAdress} deliveryAddress={deliveryAddress} setdeliveryAddress={setdeliveryAddress} deliveryName={deliveryName} setdeliveryName={setdeliveryName} deliveryPhone={deliveryPhone} setdeliveryPhone={setdeliveryPhone} deliveryCompanyName={deliveryCompanyName} setdeliveryCompanyName={setdeliveryCompanyName} deliveryPincode={deliveryPincode} setdeliveryPincode={setdeliveryPincode}
        deliveryCity={deliveryCity} setdeliveryCity={setdeliveryCity} deliveryState={deliveryState}
        setdeliveryState={setdeliveryState} deliveryClientId={deliveryClientId} setdeliveryClientId={setdeliveryClientId} handleDilveryModal={handleDilveryModal} setDilveryModal={setDilveryModal} dilveryModal={dilveryModal} />
      <div className='col-span-4 h-[85vh] overflow-y-scroll mx-6 my-6' >
        <h3 className='font-[GilroyBold] text-[1.5rem] ' >Update Order</h3>
        <div className='' >
          <ShipmentDetailsEdit
            userList={userList}
            user={user}
            setUser={setUser}
            warehouseList={warehouseList}
            pickupLocation={pickupLocation}
            setPickupLocation={setPickupLocation}
            dimentionData={dimentionData}
            setDimentionData={setDimentionData}
            setDimension={setDimension}
            dimension={dimension}
            subOrders={subOrders}
            setSubOrders={setSubOrders}
            dropLocation={dropLocation}
            setDropLocation={setDropLocation}
            mode={mode}
            setMode={setMode}
            amount={amount}
            setAmount={setAmount}
            weight={weight}
            setWeight={setWeight}
            lrNumber={lrNumber}
            setLrNumber={setLrNumber}
            orderID={orderID}
            setOrderID={setOrderID}
            lrDetails={lrDetails}
            setLrDetails={setLrDetails}
            step={step} setStep={setStep} />
          <Dimensions
            handleDimensionData={handleDimensionData}
            removeDimesion={removeDimesion}
            dimentionData={dimentionData}
            setDimentionData={setDimentionData}
            setDimension={setDimension}
            dimension={dimension}
            subOrders={subOrders}
            setSubOrders={setSubOrders}
            dropLocation={dropLocation}
            setDropLocation={setDropLocation}
            mode={mode}
            setMode={setMode}
            amount={amount}
            setAmount={setAmount}
            weight={weight}
            setWeight={setWeight}
            lrNumber={lrNumber}
            setLrNumber={setLrNumber}
            orderID={orderID}
            setOrderID={setOrderID}
            lrDetails={lrDetails}
            setLrDetails={setLrDetails}

            step={step} setStep={setStep} />
          {/* <div className='flex mx-3 gap-4 items-center justify-end' >
          <Button disabled={true} >
            Back
          </Button>
          <Button onClick={handleShippingDetails}  >
            Next
          </Button>
        </div> */}
        </div>
        <div className='' >
          <DeliveryAddress
            deliveryAddresses={deliveryAddresses}
            handleDilveryModal={handleDilveryModal}
            dropLocation={dropLocation}
            setDropLocation={setDropLocation}
          />

          {/* <div className='flex mx-3 gap-4 items-center justify-end' >
          <Button onClick={() => setStep(1)} >
            Back
          </Button>
          <Button onClick={handleDeliveryInformation} >
            Next
          </Button>
        </div> */}
        </div>
        <div className='mt-6 rounded-[24px] border border-slate-200 bg-white px-5 py-5 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
          <div className='flex gap-4 items-center justify-end' >
            <Button disabled={loading} onClick={handleConfirmOrder} >
              {loading ? "Updating ..." : "Update Order"}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditOrderPage
